import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withOverlayControls } from '@eb/eds-structure';
import { clickCTASeasonal } from '../../redux/content/actions';

import { FullbleedHeaderBackgroundContainer } from '../FullbleedHeaderBackgroundContainer';

import { HeaderTitle } from '../../components/HeaderTitle';

import { HEADER_PROPTYPES } from './constants';

import './FullbleedHeader.scss';

export class FullbleedHeader extends Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        // eslint-disable-next-line
        history: PropTypes.object,
        header: PropTypes.shape(HEADER_PROPTYPES),
        clickCTASeasonal: PropTypes.func,
    };

    render() {
        const { header = {}, clickCTASeasonal } = this.props;

        return (
            <section className="feed-fullbleed-header">
                <div className="feed-fullbleed-header__wrapper">
                    <FullbleedHeaderBackgroundContainer
                        type="MainHeaderBackground"
                        isSeasonal={header.shouldShowCustomContent}
                        placeholder={header.headerImagePlaceholder}
                    />

                    <div className="feed-fullbleed-header__content">
                        <div className="eds-layout eds-layout--has-large-max-width eds-layout--has-horizontal-gutters">
                            <div className="eds-layout__body">
                                <HeaderTitle
                                    header={header}
                                    clickCTASeasonal={clickCTASeasonal}
                                    fullbleed={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const _mapStateToProps = ({ header, app }) => ({
    header,
    isLoading: app.loadingState && app.loadingState.isFeLoading,
});

const _mapDispatchToProps = {
    clickCTASeasonal,
};

export default withOverlayControls(
    connect(_mapStateToProps, _mapDispatchToProps)(FullbleedHeader),
);
